import { Link, useNavigate } from "react-router-dom";

import { ArrowLeft } from "lucide-react";

import { useCreateClaim, useCurrentEmployee } from "../hooks";

import { ClaimDraftForm } from "../components/ClaimDraftForm";

import { PageLoader } from "#/components/common/PageLoader";

import { ErrorState } from "#/components/common/ErrorState";

export default function ClaimCreatePage() {

  const navigate = useNavigate();

  const employeeQuery = useCurrentEmployee();

  const createClaim = useCreateClaim();

  if (employeeQuery.isLoading) {

    return <PageLoader label="Loading employee profile..." />;

  }

  if (employeeQuery.error || !employeeQuery.data) {

    return (

      <ErrorState message="You need an employee profile before creating claims." />

    );

  }

  return (

    <div className="space-y-6">

      <Link

        to="/claims"

        className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-700 hover:underline"

      >

        <ArrowLeft className="h-4 w-4" />

        Back to claims

      </Link>

      <div>

        <h1 className="text-2xl font-bold text-slate-900">New claim</h1>

      </div>

      <ClaimDraftForm

        loading={createClaim.isPending}

        onSubmit={async (values) => {

          const created = await createClaim.mutateAsync({

            employeeId: employeeQuery.data.id,

            claimType: values.claimType,

            purpose: values.purpose,

          });

          navigate(`/claims/${created.id}/edit`);

        }}

      />

    </div>

  );

}